module.exports = require("vinyl-read");


//////////////////
// WEBPACK FOOTER
// external "vinyl-read"
// module id = 80
// module chunks = 0 1 2 3 4 5 6 7 10 11